import { FetchHelper, type ItemPriceRequestDto, type ItemPriceResultDto } from "@sticker-giant/sg-frontend-common";

export class PricingClientPublic extends FetchHelper {
  getPricingForItem = async (item: ItemPriceRequestDto): Promise<ItemPriceResultDto | undefined> =>
    await this.postRequest(`item`, item, "Failed to get pricing for item");
}
